import React from "react";
import PropTypes from "prop-types";

function IconInfoYellow(props) {
  return (
    <svg
      width={props.width ? props.width : "31"}
      height={props.height ? props.height : "31"}
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4200_31159)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.0938 15.5C28.0938 18.8401 26.7669 22.0433 24.4051 24.4051C22.0433 26.7669 18.8401 28.0938 15.5 28.0938C12.1599 28.0938 8.95666 26.7669 6.59487 24.4051C4.23309 22.0433 2.90625 18.8401 2.90625 15.5C2.90625 12.1599 4.23309 8.95666 6.59487 6.59487C8.95666 4.23309 12.1599 2.90625 15.5 2.90625C18.8401 2.90625 22.0433 4.23309 24.4051 6.59487C26.7669 8.95666 28.0938 12.1599 28.0938 15.5ZM31 15.5C31 19.6109 29.367 23.5533 26.4602 26.4602C23.5533 29.367 19.6109 31 15.5 31C11.3891 31 7.44666 29.367 4.53984 26.4602C1.63303 23.5533 0 19.6109 0 15.5C0 11.3891 1.63303 7.44666 4.53984 4.53984C7.44666 1.63303 11.3891 0 15.5 0C19.6109 0 23.5533 1.63303 26.4602 4.53984C29.367 7.44666 31 11.3891 31 15.5ZM12.1094 20.3438C11.724 20.3438 11.3544 20.4968 11.0819 20.7694C10.8093 21.0419 10.6562 21.4115 10.6562 21.7969C10.6562 22.1823 10.8093 22.5519 11.0819 22.8244C11.3544 23.0969 11.724 23.25 12.1094 23.25H18.8906C19.276 23.25 19.6456 23.0969 19.9181 22.8244C20.1907 22.5519 20.3438 22.1823 20.3438 21.7969C20.3438 21.4115 20.1907 21.0419 19.9181 20.7694C19.6456 20.4968 19.276 20.3438 18.8906 20.3438H16.9531V13.5625H13.5625C13.1771 13.5625 12.8075 13.7156 12.535 13.9881C12.2625 14.2606 12.1094 14.6302 12.1094 15.0156C12.1094 15.401 12.2625 15.7706 12.535 16.0431C12.8075 16.3157 13.1771 16.4688 13.5625 16.4688H14.0469V20.3438H12.1094ZM15.5 11.625C16.0139 11.625 16.5067 11.4209 16.87 11.0575C17.2334 10.6942 17.4375 10.2014 17.4375 9.6875C17.4375 9.17364 17.2334 8.68083 16.87 8.31748C16.5067 7.95413 16.0139 7.75 15.5 7.75C14.9861 7.75 14.4933 7.95413 14.13 8.31748C13.7666 8.68083 13.5625 9.17364 13.5625 9.6875C13.5625 10.2014 13.7666 10.6942 14.13 11.0575C14.4933 11.4209 14.9861 11.625 15.5 11.625Z"
          fill="#F9B233"
        />
      </g>
      <defs>
        <clipPath id="clip0_4200_31159">
          <rect width="31" height="31" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

IconInfoYellow.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

export default IconInfoYellow;
